<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Events</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <h5>Add Step to {{ alert.name }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form>
          <div class="form-group">
            <label for="ddlOrderType">Order Type</label>
            <select
              class="form-control"
              id="ddlOrderType"
              v-model="alert_step.alert_step_order_type_id"
            >
              <option
                v-for="alert_step_order_type in alert_step_order_types"
                :key="alert_step_order_type.alert_step_order_type_id"
                v-bind:value="alert_step_order_type.alert_step_order_type_id"
              >{{ alert_step_order_type.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="ddlCommandType">Command Type</label>
            <select
              class="form-control"
              id="ddlCommandType"
              v-model="alert_step.alert_step_command_type_id"
            >
              <option value="0">Select..</option>
              <option
                v-for="alert_step_command_type in filtered_alert_step_command_types"
                :key="alert_step_command_type.alert_step_command_type_id"
                v-bind:value="alert_step_command_type.alert_step_command_type_id"
              >{{ alert_step_command_type.name }}</option>
            </select>
          </div>
          <div v-if="[1,7,8].includes(alert_step.alert_step_command_type_id)">
            <div class="form-group">
              <label for="ddlZone">Zone</label>
              <div class="input-group mb3">
              <select class="form-control" id="ddlZone" v-model="alert_step.zone_id">
                <option value="0">Select..</option>
                <option
                  v-for="zone in filtered_zones"
                  :key="zone.zone_id"
                  v-bind:value="zone.zone_id"
                >[{{ zone.site.name }}] {{ zone.name }}</option>
              </select>
                <div class="input-group-append" v-if="[1,7].includes(alert_step.alert_step_command_type_id)">
                  <button type="button" class="btn btn-secondary" @click="createNewZone()">Create New..</button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 1">
            <SoundDropDownAndPreview tag="alert" v-model="alert_step.sound"></SoundDropDownAndPreview>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 2">
            <label>Build Command</label>
            <div class="form-group">
              <select
                class="form-control"
                v-model="built_in_command.type"
                @change="generateBarixCommand"
              >
                <option value="0">Select..</option>
                <option value="1">Open</option>
                <option value="2">Close</option>
              </select>
            </div>
            <div class="form-group">
              <select
                class="form-control"
                v-model="built_in_command.io"
                @change="generateBarixCommand"
              >
                <option value="1">Relay 1</option>
                <option value="2">Relay 2</option>
                <option value="201">Input 1</option>
                <option value="202">Input 2</option>
                <option value="203">Input 3</option>
                <option value="204">Input 4</option>
                <option value="205">Input 5</option>
                <option value="206">Input 6</option>
                <option value="207">Input 7</option>
                <option value="208">Input 8</option>
              </select>
            </div>
            <div class="form-group">
              <label for="txtBarixCommand">Barix Command</label>
              <input
                type="text"
                class="form-control"
                id="txtBarixCommand"
                v-model="alert_step.barix_command"
              />
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 3">
            <div class="form-group">
              <label for="numSleepDuration">Sleep Duration</label>
              <input
                type="number"
                class="form-control"
                id="numSleepDuration"
                v-model="alert_step.sleep_duration"
              />
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 4">
            <div class="form-group">
              <label for="ddlAlertSteps">Go to Step</label>
              <select class="form-control" id="ddlAlertSteps" v-model="alert_step.to_alert_step_id">
                <option value="0">Select..</option>
                <option
                  v-for="_alert_step in filtered_alert_steps"
                  :key="_alert_step.alert_step_id"
                  v-bind:value="_alert_step.alert_step_id"
                >{{ _alert_step.order }} - {{ _alert_step.alert_step_command_type.name }}</option>
              </select>
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 5">
            <div class="form-group">
              <label for="txtMessage">Message</label>
              <input class="form-control" type="text" id="txtMessage" v-model="alert_step.message" />
              <small
                class="form-text text-muted"
              >Contacts set to receive 'all alerts sms' will not show up in the below list but will automatically be sent the sms message.</small>
            </div>
          </div>
          <div v-if="[7,8].includes(alert_step.alert_step_command_type_id)">
            <div class="form-group">
              <label for="ddlVisuals">Visual</label>
              <div class="input-group mb3">
                <select class="form-control" id="ddlVisuals" v-model="alert_step.advanced_visual_id">
                  <option value="0">Select..</option>
                  <option
                    v-for="advanced_visual in filtered_advanced_visuals"
                    :key="advanced_visual.advanced_visual_id"
                    v-bind:value="advanced_visual.advanced_visual_id"
                  >{{ advanced_visual.name }}</option>
                </select>
                <div class="input-group-append" v-if="alert_step.alert_step_command_type_id === 7">
                  <button type="button" class="btn btn-secondary" @click="createNewVisual()">Create New..</button>
                </div>
              </div>
            </div>
          </div>
          <br />
        </form>
      </div>
      <div class="col-6">
        <StepsTable :alert_id="alert_id" :preview_only="true"></StepsTable>
      </div>
    </div>
    <br><br><br>
    <div class="row" v-if="alert_step.alert_step_command_type_id === 5">
      <div class="col-12">
        <div class="row">
          <div class="col-5">
            <div class="form-group">
              <label for="txtPhoneToAddName">Name</label>
              <input
                class="form-control"
                type="text"
                id="txtPhoneToAddName"
                v-model="phone_to_add.name"
              />
            </div>
            <div class="form-group">
              <label for="txtPhoneToAddPhoneNumber">Phone Number</label>
              <vue-tel-input
                :onlyCountries="['US']"
                :validCharactersOnly="true"
                @input="updatePhoneNumberProperties"
                v-model="phone_to_add.phone_number.display_text"
              ></vue-tel-input>
            </div>
          </div>
          <div class="col-2 middle-btn-col">
            <button type="button" class="btn btn-light" @click="addPhoneNumber()">
              <i class="fa fa-arrow-right fa-fw" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-light" @click="removePhoneNumbers()">
              <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col-5">
            <div class="card">
              <div class="card-header bg-hub-primary text-white">Phone Numbers</div>
              <div class="card-block">
                <select
                  multiple
                  class="form-control devices-select"
                  v-model="selected_phone_numbers"
                >
                  <option
                    v-for="alert_step_phone_number in alert_step.alert_step_phone_numbers"
                    v-bind:value="alert_step_phone_number.phone_number"
                    :key="alert_step_phone_number.phone_number"
                  >{{ alert_step_phone_number.name }} ({{ alert_step_phone_number.phone_number }})</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
        <router-link
          :to="{ name: 'AlertSummary', params: { alert_id: alert.alert_id } }"
          class="btn btn-secondary"
        >Cancel</router-link>
      </div>
    </div>
    <Modal>
      <template v-slot:title>
        <span v-if="modal_type === 'Zone'">Add Zone</span>
        <span v-else>Add Visual</span>
      </template>
      <template v-slot:body>
        <ZoneAdd :in_modal="true" v-if="modal_type === 'Zone'"></ZoneAdd>
        <AdvancedVisualAdd :in_modal="true" :alert_id="alert_id" v-else></AdvancedVisualAdd>
      </template>
    </Modal>
    <GuidedPrompt
      :passed_state="guided_states.ASK_CREATE_ANOTHER_STEP"
      :creation_object="this.alert_step"
    ></GuidedPrompt>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import SoundDropDownAndPreview from '../../components/SoundDropDownAndPreview'
import StepsTable from '../../components/Alert/StepsTable'
import Modal from '../../components/Modal'
import ZoneAdd from '../Zone/Manager/Add'
import AdvancedVisualAdd from './Visual/AddAdvanced'
import GuidedPrompt from '../../components/Alert/GuidedPrompt'

export default {
  props: {
    alert_id: {
      type: [Number, String],
      required: true
    },
    alert_step_order_type_id: {
      type: Number,
      default: 1
    }
  },
  data: function () {
    return {
      modal_type: 'Zone',
      built_in_command: {
        type: 0,
        io: 1
      },
      phone_to_add: {
        name: '',
        phone_number: {
          display_text: '',
          properties: {
            isValid: false
          }
        }
      },
      selected_phone_numbers: [],
      alert_step: {
        alert_step_id: 0,
        alert_id: this.alert_id,
        alert_step_order_type_id: this.alert_step_order_type_id,
        alert_step_command_type_id: 0,
        zone_id: 0,
        sound_id: 0,
        sound: '',
        advanced_visual_id: 0,
        barix_command: '',
        message: '',
        alert_step_phone_numbers: [],
        sleep_duration: 0,
        to_alert_step_id: 0,
        order: 0
      }
    }
  },
  components: { SoundDropDownAndPreview, StepsTable, Modal, ZoneAdd, AdvancedVisualAdd, GuidedPrompt },
  computed: {
    ...mapGetters({
      alert: 'singleAlert',
      alert_steps: 'allAlertSteps',
      alert_step_order_types: 'allAlertStepOrderTypes',
      alert_step_command_types: 'allAlertStepCommandTypes',
      feature_sms_enabled: 'featureSMSEnabled',
      feature_sms_max_phone_numbers: 'featureSMSMaxPhoneNumbers',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
      feature_g2_secure_enabled: 'featureG2SecureEnabled',
      guided_states: 'allGuidedStates',
      advanced_visuals: 'allAdvancedVisuals',
      zones: 'allZones',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_zones: function () {
      // TODO Account for Zone Tags COMM-188
      let context = this
      return this.zones.filter(
        function (zone) {
          if (
            zone.site_id === context.scoped_site_id ||
            context.scoped_site_id === 1
          ) {
            if ([7, 8].includes(context.alert_step.alert_step_command_type_id)) {
              return zone.zone_type_id === 4
            }
            else {
              return zone.zone_type_id !== 4
            }
          }
        }
      )
    },
    filtered_alert_step_command_types: function () {
      let context = this

      return this.alert_step_command_types.filter(function (commandType) {
        if (
          !context.feature_sms_enabled &&
          commandType.alert_step_command_type_id === 5
        ) {
          return false
        }

        if (
          !context.feature_visual_alert_enabled &&
          [7, 8].includes(commandType.alert_step_command_type_id)
        ) {
          return false
        }

        if (commandType.alert_step_command_type_id === 6) {
          return false
        }

        if (context.alert.device_id === null) {
          if (commandType.alert_step_command_type_id === 2) {
            return false
          } else {
            return true
          }
        }

        return true
      })
    },
    filtered_alert_steps: function () {
      return this.alert_steps.filter(
        alertStep =>
          alertStep.alert_id === this.alert.alert_id &&
          alertStep.alert_step_order_type_id ===
            this.alert_step.alert_step_order_type_id
      )
    },
    filtered_advanced_visuals: function () {
      return this.advanced_visuals.filter(v => v.alert_id === this.alert.alert_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getAlert', this.alert_id)
    this.$store.dispatch('getAlertSteps', this.alert_id)
    this.$store.dispatch('getAlertStepOrderTypes')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX')
    this.$store.dispatch('getAlertStepCommandTypes')
    this.$store.dispatch('getAdvancedVisuals')
    this.$store.dispatch('getZones')
  },
  methods: {
    createNewZone () {
      this.modal_type = 'Zone'
      $('#genericModal').modal('show')
    },
    createNewVisual () {
      this.modal_type = 'Visual'
      $('#genericModal').modal('show')
    },
    generateBarixCommand () {
      this.alert_step.barix_command = 'setio,' + this.built_in_command.io + ','

      if (this.built_in_command.type === '1') {
        this.alert_step.barix_command += '0'
      } else if (this.built_in_command.type === '2') {
        this.alert_step.barix_command += '1'
      }
    },
    updatePhoneNumberProperties (num, data) {
      this.phone_to_add.phone_number.properties = data
    },
    addPhoneNumber () {
      if (
        this.alert_step.alert_step_phone_numbers.length <
        Number(this.feature_sms_max_phone_numbers)
      ) {
        if (!_.isEmpty(this.phone_to_add.name)) {
          if (this.phone_to_add.phone_number.properties.isValid) {
            this.alert_step.alert_step_phone_numbers.push({
              alert_step_id: this.alert_step_id,
              name: this.phone_to_add.name,
              phone_number: this.phone_to_add.phone_number.properties.number.replace(
                /\s/g,
                ''
              )
            })

            this.phone_to_add.name = ''
            this.phone_to_add.phone_number = {
              display_text: '',
              properties: { isValid: false }
            }
          } else {
            alert('Please enter a valid phone number.')
          }
        } else {
          alert('Please enter a name for the phone number.')
        }
      } else {
        alert(
          'The limit of ' +
            this.feature_sms_max_phone_numbers +
            ' phone numbers has been reached.'
        )
      }
    },
    removePhoneNumbers () {
      for (let i = 0; i < this.selected_phone_numbers.length; i++) {
        let selectedPhoneNumber = this.selected_phone_numbers[i]
        let phoneNumberToRemove = this.alert_step.alert_step_phone_numbers.find(
          function (ele) {
            if (ele.phone_number === selectedPhoneNumber) {
              return true
            }
          }
        )
        this.alert_step.alert_step_phone_numbers.splice(
          this.alert_step.alert_step_phone_numbers.indexOf(phoneNumberToRemove),
          1
        )
      }
    },
    submit () {
      $('#guidedPrompt').modal('show')
    }
  }
}
</script>

<style scoped>
</style>
